module.exports = __webpack_public_path__ + "img/dt-new.97046f71.png";